import {AfterViewInit, Directive, ElementRef, forwardRef, Input, Renderer2} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {isNullOrUndefined} from "util";
import {debounceTime} from "rxjs/operators";
import {fromEvent} from "rxjs/observable/fromEvent";

/**
 * Created by afuhr on 05.01.2017.
 */


@Directive({
  selector: '[debounceTime]',
  //host: {'(change)': 'doOnChange($event.target)', '(blur)': 'onTouched()'},
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DebounceInputControlValueAccessor), multi: true
  }]
})
export class DebounceInputControlValueAccessor implements ControlValueAccessor, AfterViewInit {

  onChange = (_) => {
  };
  onTouched = () => {
  };

  @Input()
  debounceTime: number;

  constructor(private _elementRef: ElementRef, private _renderer: Renderer2) {

  }

  ngAfterViewInit() {
    fromEvent(this._elementRef.nativeElement, 'keyup')
      .pipe(
        debounceTime(this.debounceTime)
      ).subscribe((event: any) => {
      this.onChange(event.target.value);
    });
  }

  writeValue(value: any): void {
    var normalizedValue = isNullOrUndefined(value) ? '' : value;
    this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
  }

  registerOnChange(fn: () => any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => any): void {
    this.onTouched = fn;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/forms/validators/debounce-input.ts